// extracted by mini-css-extract-plugin
export default {"container":"dt5lnKzZ9Rsm67M74vhq","tabs":"qMXZJ0lSXCCyuh2SYk2y","tab":"vNLQM6jfTHcxLhg6Kdwq","body":"o3wMN1QBDCXDdNMf0n3S"};